import { API_URL_MARKET_OFFER_ACTION } from "../../actions";
import client from "../../client";
import { type DeliveryDisputeTopic, type Offer } from "./components/OfferCard/interfaces";

export interface CompleteDeliveryPayload {
  delivered_quantity: string;
  paid: boolean;
  payment_amount?: string;
  delivery_payment_method?: string;
  includes_delivery_cost?: boolean;
  delivery_note?: File | null;
}

const MULTIPART_CONFIG = { headers: { "Content-Type": "multipart/form-data" } };

export const completeDelivery = (offerId: number, payload: CompleteDeliveryPayload) => {
  const form = new FormData();
  form.append("delivered_quantity", payload.delivered_quantity);
  form.append("paid", String(payload.paid));
  if (payload.paid) {
    form.append("payment_amount", payload.payment_amount ?? "");
    form.append("delivery_payment_method", payload.delivery_payment_method ?? "");
    form.append("includes_delivery_cost", String(!!payload.includes_delivery_cost));
  }
  if (payload.delivery_note) {
    form.append("delivery_note", payload.delivery_note);
  }
  return client.post<Offer>(
    API_URL_MARKET_OFFER_ACTION(offerId, "complete_delivery"),
    form,
    MULTIPART_CONFIG
  );
};

export const confirmDelivery = (offerId: number) =>
  client.post<Offer>(API_URL_MARKET_OFFER_ACTION(offerId, "confirm_delivery"));

export const disputeDelivery = (offerId: number, topics: DeliveryDisputeTopic[], comment: string) =>
  client.post<Offer>(API_URL_MARKET_OFFER_ACTION(offerId, "dispute_delivery"), {
    topics,
    comment,
  });

export const rejectDelivery = (offerId: number, reason: number, comment: string) =>
  client.post<Offer>(API_URL_MARKET_OFFER_ACTION(offerId, "reject_delivery"), {
    reason,
    comment,
  });
